import React from 'react';
import MaterialSelect from './materialSelect';
import SaunaImageContainer from '../containers/SaunaImageContainer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import localization from '../helpers/localization.js';
import { lightType } from '../helpers/enums';



const ligthSelectionPage = ({
    showPrices,
    prevPage,
    nextPage,
    lightingChanged,
    lightOptions,
    selected,
    lightPrices,
    showLightInstructions
}) => {
    return (<div className="page">
        <SaunaImageContainer />
        <div className="materialSelections" >
            <Row>
                <Col sm={12}><MaterialSelect columnNum={3} autoAdjustWidth={true} materials={lightOptions} onChange={lightingChanged} header={localization.ligthing} selected={selected} showPrices={showPrices} prices={lightPrices} onInfoClick={showLightInstructions} /></Col>            

            </Row>
            <div className="changePhaseRow">
                <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
            </div>
        </div>
    </div>
    )
}
export default ligthSelectionPage

